module.exports = __webpack_public_path__ + "static/media/01-3-x-copy-2@3x.0f795490.png";